import React from 'react';
import CardGrid from './CardGrid'
import CardDetails from './CardDetails'
import { Amplify } from 'aws-amplify';
import awsconfig from '../aws-exports'; 
Amplify.configure(awsconfig);


const GalleryGrid = () => {
    return (
          <div className="ui grid">
            <div className="twelve wide column">
              <br/>
              <CardGrid gallery='true'/>
            </div>
            <div className="four wide column">
              <br/>
              <CardDetails isGallery='true'/>
            </div> 
          </div>
      );
}

export default GalleryGrid